import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'diocese-collection',
  templateUrl: './diocese-collection.component.html',
  styleUrls: ['./diocese-collection.component.scss'],
})
export class DioceseCollectionComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
